import { Controller } from "@hotwired/stimulus"
import { TurboBeforeFetchRequestEvent, TurboSubmitStartEvent } from "@hotwired/turbo"
import Confirmation from "../../confirmation"
import SelectionToolbarController from "../selection_toolbar_controller"

export default class ShowController extends Controller {

  declare removeBtnTarget: HTMLButtonElement
  declare toolbarTarget: HTMLElement
  declare tableTarget: HTMLTableElement

  static targets = [
    "removeBtn",
    "toolbar",
    "table",
  ]

  removeBtnTargetConnected(el: HTMLButtonElement) {
    const form = el.closest("form")
    if (!form) {
      return
    }

    form.addEventListener("turbo:before-fetch-request", async (event: TurboBeforeFetchRequestEvent) => {
      event?.preventDefault()

      if (await Confirmation.confirmBulkRemove("clients")) {
        event.detail.resume(null)
      } else {
        this.getToolbarController()?.clearSelected()
      }
    })

    form.addEventListener("turbo:submit-start", (event: TurboSubmitStartEvent) => {
      const selectionToolbar = this.getToolbarController()
      const ids = selectionToolbar?.selectedIds() || []
      ids.forEach(id => {
        event.detail.formSubmission.fetchRequest.body
          .append("group[ids][]", id)
      })
    })
  }

  getClientName(el: EventTarget | null) {
    if (el instanceof HTMLElement) {
      return el.closest("tr")?.dataset.clientName
    }
  }

  async confirmRemove(event: TurboBeforeFetchRequestEvent) {
    event.preventDefault()

    if (await Confirmation.confirmRemove(this.getClientName(event.target) || "this client")) {
      event.detail.resume(null)
    }
  }

  appendUrlParams(event: TurboSubmitStartEvent) {
    const urlParams = new URLSearchParams(window.location.search)
    urlParams.forEach((value, key) => {
      event.detail.formSubmission.fetchRequest.body.append(key, value)
    })
  }

  getToolbarController(): SelectionToolbarController | null {
    return SelectionToolbarController.getInstance(this.toolbarTarget)
  }
}
